import React from "react";
import { Helmet } from "react-helmet";
// import classes from "./EditInvoices.module.scss";

const EditIntegrationInvoices = () => {
  return (
    <>
      <Helmet>
        <title>View Integration Invoices | DDD Invoices</title>
      </Helmet>
      <div className="w-100 h-100">
        <iframe
          src="@invt_cki"
          title="edit-invoices-layout"
          style={{ width: "100%", height: "100%" }}
        ></iframe>
      </div>
    </>
  );
};

export default EditIntegrationInvoices;
